( function () {
	'use strict';

	function selectInput ( $document, $filter, _, $timeout, moment ) {
		function link ( scope, element ) {
			scope.serverTimeout = { };

			if ( scope.pointer === 'FirstName' ) {
				scope.firstName = true;
			}

			function hidePopElement () {
				$document.off( 'click' );
				angular.element( element ).find( '.popup-select' ).addClass( 'hidden' );
			}

			function hideElement ( isActive ) {
				if ( isActive ) {
					return $document.off( 'click' );
				}
				$document.on( 'click', function ( event ) {
					if ( !element.is( event.currentTarget ) ) {
						hidePopElement();
						scope.searchItem = '';
						return scope.$apply();
					}
				} );
			}

			function showElement () {
				element.on( 'click', function ( event ) {
					var currentEl = angular.element( event.currentTarget ).find( '.popup-select' );

					$document.off( 'click' );
					event.stopPropagation();

					if ( !scope.disable ) {
						angular.element( '.popup-select' ).not( currentEl ).addClass( 'hidden' );
						angular.element( event.currentTarget ).find( '.popup-select' ).removeClass( 'hidden' );

						$timeout( function () {
							angular.element( event.currentTarget ).find( 'input:text' )[ 0 ].focus();
						} );
					}
					hideElement();
				} ).children().find( 'ul' ).on( 'click', function () {
					return false;
				} );
			}

			function search ( row ) {
				var searchItem = _.escapeRegExp( scope.searchItem );

				if ( !searchItem ) {
					return true;
				}

				var pattern = new RegExp( searchItem, 'gi' );

				if ( scope.pointer === 'FirstName' ) {
					return ( row[ scope.pointer ] + ' ' + row.LastName ).match( pattern );
				}
				return row[ scope.pointer ].match( pattern );
			}

			function resultOption ( data ) {
				if ( scope.isRemoved ) {
					scope.isRemoved = false;
				}

				hidePopElement();

				if ( scope.pointer !== 'FirstName' ) {
					scope.resultSelected = data;
				} else {
					scope.teacher = data.FirstName + ' ' + data.LastName;

					scope.$parent.vm.prevTeacher = {
						'pointer' : 'FirstName',
						'data'    : data
					};
				}

				if ( scope.pointer === 'SchoolName' ) {
					scope.$parent.vm.getTeachers = data;
				}

				var selections = {
					'pointer' : scope.pointer,
					'data'    : data
				};

				if ( !scope.$parent.vm.selections.length ) {
					scope.$parent.vm.selections.push( selections );
				}

				// check if pointer already exist
				var pointerExist = _.chain( scope.$parent.vm.selections ).pluck( 'pointer' ).includes( scope.pointer ).value();
				var dataExist    = _.includes( scope.$parent.vm.selections, selections );
				var index        = _.findIndex( scope.$parent.vm.selections, { 'pointer' : scope.pointer } );

				if ( !pointerExist ) {
					return scope.$parent.vm.selections.push( selections );
				}

				scope.$parent.vm.selections.splice( index, 1, selections );

				if ( !dataExist && scope.pointer === 'SchoolName' ) {
					scope.$parent.vm.teacher = 'Select a Teacher';
					scope.$parent.vm.selections = _.reject( scope.$parent.vm.selections, 'pointer', 'FirstName' );
				}
			}

			function convertDate ( date ) {
				return moment( date ).format( 'MM/DD/YYYY' );
			}

			function activate () {
				showElement();
				hideElement( true );

				if ( typeof scope.templateSelected === 'object' ) {
					scope.resultSelected = scope.templateSelected;
				} else {
					scope.resultSelected = scope.onEditTemplate;
				}
			}

			scope.$on( 'startObs:timeout', function ( ev, type ) {
				scope.serverTimeout[ type ] = true;
			} );

			scope.$on( 'removeObservee', function ( ev, data ) {
				scope.$parent.vm.selections.splice( scope.$parent.vm.selections.indexOf( data ), 1 );
			} );

			scope.resultOption   = resultOption;
			scope.search         = search;
			scope.hidePopElement = hidePopElement;
			scope.convertDate    = convertDate;

			activate();
		}

		var directive = {
			'link'        : link,
			'restrict'    : 'E',
			'templateUrl' : '/templates/observations/observation-start/select.html',
			'require'     : '?ngModel',
			'scope'       : {
				'choices'          : '=',
				'pointer'          : '@',
				'disable'          : '=',
				'placeholder'      : '@',
				'teacher'          : '=',
				'marker'           : '@',
				'isRemoved'        : '=',
				'isOpenCalendar'   : '=',
				'emptyMessage'     : '=',
				'fetchTimeout'     : '=',
				'onTemplate'       : '=',
				'maxLength'        : '=',
				'onEditTemplate'   : '=',
				'templateSelected' : '='
			}
		};

		return directive;
	}

	angular
		.module( 'app.observations' )
		.directive( 'selectInput', selectInput );

	selectInput.$inject = [ '$document', '$filter', '_', '$timeout', 'moment' ];
} )( );
